// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#reject_contract_approve_modal .modal-body{
    height: 200px;
}

.file-upload-custom{
    width: 25px;
    height: 25px;
    top: 20%;
    right: 2%;
    background-image: url(/assets/img/icons/image.png);
    background-repeat: no-repeat;
    background-size: contain;
}
.file-upload-custom > input[type=file]{
    opacity: 0;
}
/* public upload block */
.uploadfile-block{
    position: relative;
    width: 85px;
    height: 85px;
    background-color: gainsboro;
}
.uploadfile-block > span{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
}
.uploadfile-block > span > input{
    width: 100%;
    height: 100%;
    opacity: 0;
}
.uploadfile-block > span::before{
    position: absolute;
    top: 25%;
    left: 30%;
    font-size: 2.9rem;
}
.uploadfile-block > span > img{
    width: 100%;
    height: 100%;
}
.uploadfile-block > button{
    width: 100%;
    height: 100%;
}
:host ::ng-deep .p-dropdown {
    width: 100%;
}
.is-disabled{
    background: #e9ecef;
}

a:hover {
    cursor: pointer;
}

.label-bold {
    font-size: 1.5rem;
    font-weight: bold;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/contracts/contract-modal/contract-modal.component.css"],"names":[],"mappings":";AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,kDAAkD;IAClD,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IAGT,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AALtB;AAOA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAAA,woFAAwoF","sourcesContent":["\n#reject_contract_approve_modal .modal-body{\n    height: 200px;\n}\n\n.file-upload-custom{\n    width: 25px;\n    height: 25px;\n    top: 20%;\n    right: 2%;\n    background-image: url(/assets/img/icons/image.png);\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.file-upload-custom > input[type=file]{\n    opacity: 0;\n}\n/* public upload block */\n.uploadfile-block{\n    position: relative;\n    width: 85px;\n    height: 85px;\n    background-color: gainsboro;\n}\n.uploadfile-block > span{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n.uploadfile-block > span{\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n.uploadfile-block > span > input{\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n}\n.uploadfile-block > span::before{\n    position: absolute;\n    top: 25%;\n    left: 30%;\n    font-size: 2.9rem;\n}\n.uploadfile-block > span > img{\n    width: 100%;\n    height: 100%;\n}\n.uploadfile-block > button{\n    width: 100%;\n    height: 100%;\n}\n:host ::ng-deep .p-dropdown {\n    width: 100%;\n}\n.is-disabled{\n    background: #e9ecef;\n}\n\na:hover {\n    cursor: pointer;\n}\n\n.label-bold {\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
